'use strict';

const TrackJS = require('trackjs').TrackJS;

let application = null;
if (location.host.indexOf('jiji-app.appspot.com') >= 0) {
    application = 'jiji-app';
} else if (location.host.indexOf('jiji-stage.appspot.com') >= 0) {
    application = 'jiji-stage';
} else if (location.host.indexOf('jiji-dev.appspot.com') >= 0) {
    application = 'jiji-dev';
}

if (application) {
    let trackJSApp = application;
    if (application === 'jiji-app') {
        trackJSApp = 'balus-app'; // ログイン対象サービスが増えるまでの間は、 balus-app に共存する
    } else {
        trackJSApp = 'shared-dev'; // jiji-app 以外の環境では、共有開発環境用 shared-dev に設定する
    }

    console.log('TrackJS enabled with', trackJSApp, application);

    TrackJS.install({
        token: "5246d62767494470abfdbc6d1a011cf4",
        application: trackJSApp
    });
    TrackJS.addMetadata('appName', application);
}

module.exports = TrackJS;



// WEBPACK FOOTER //
// ./jiji/infra/trackjs.js